// extracted by mini-css-extract-plugin
export var blink = "_6m-2";
export var cursor = "_6m-1";
export var reactMarkdown = "_6m-3";
export var streamingText = "_6m-0";